import React from 'react';
import './Section4.css';

const Section4 = () => (
  <section className="section4" id="who-we-are">
    <div className="section4-left">
      <div className="styled-image-container">
        <img
          src="/about_as.webp"
          alt="About Appstoria"
          className="section4-illustration"
        />
      </div>
    </div>
    <div className="section4-right">
      <h2>About us</h2>
      <p>We are a tech-driven company focused on creating, supporting, and delivering mobile and web applications. With a focus on rapid prototyping and flawless execution, our development approach ensures that from conceptualization to deployment, every app we create is a seamless blend of creativity, functionality, and practicality, aimed at enhancing user experiences and driving success.</p>
      <p>Our team thrives on innovation, continuously exploring emerging technologies to keep our solutions ahead of the curve. By combining technical expertise with a deep understanding of market trends, we deliver applications that not only perform but also inspire.</p>
    </div>
    <button className="section-up" aria-label="Back to top" onClick={()=>window.scrollTo({top:0,behavior:'smooth'})}>
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="16" cy="16" r="14" stroke="#2563eb" strokeWidth="2.5"/>
        <path d="M16 22V10M16 10L10 16M16 10L22 16" stroke="#2563eb" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </button>
  </section>
);

export default Section4;
